/* Fabric Alex PDP extras v4 — resilient mount for thread + 20/50 cm cuts. */
(function () {
  'use strict';

  var attempts = 0;
  var maxAttempts = 60;
  var retryTimer = null;
  var initialized = false;
  var cfg = null;
  var section = null;
  var root = null;
  var cards = {};
  var variants = [];
  var current = null;
  var colorIndex = -1;

  function isBg() {
    var locale = cfg && cfg.locale ? cfg.locale : (document.documentElement.lang || '');
    return String(locale).toLowerCase().indexOf('bg') === 0;
  }

  function copy() {
    return isBg() ? {
      aria: 'Допълнителни опции',
      thread: 'Подходящ конец',
      threadDescription: 'Избираме най-близкия цвят',
      threadUnit: '200 м',
      twenty: 'Купи 20 см',
      twentyDescription: 'От избрания продукт',
      half: 'Купи 50 см',
      halfDescription: 'От избрания продукт',
      added: 'Добавено ✓',
      error: 'Не успяхме да добавим. Опитайте отново.',
      threadNote: 'Ще изберем най-близкия подходящ цвят'
    } : {
      aria: 'Additional purchase options',
      thread: 'Matching thread',
      threadDescription: 'We choose the closest shade',
      threadUnit: '200m',
      twenty: 'Buy 20 cm',
      twentyDescription: 'For the selected product',
      half: 'Buy 50 cm',
      halfDescription: 'For the selected product',
      added: 'Added ✓',
      error: 'Could not add this item. Please try again.',
      threadNote: 'We will choose the closest matching shade'
    };
  }

  function icon(type) {
    if (type === 'thread') {
      return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 4h10M7 20h10M8.5 4c1.8 2.2 1.8 13.8 0 16m7-16c-1.8 2.2-1.8 13.8 0 16M8 8h8M8 16h8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
    }
    if (type === 'half') {
      return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8.2h16v7.6H4z" stroke="currentColor" stroke-width="1.7"/><path d="M7 8.3v3m3-3v1.8m3-1.8v3m3-3v1.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 6.5h14v11H5z" stroke="currentColor" stroke-width="1.7"/><path d="M8 6.7v2.6m3-2.6v1.5m3-1.5v2.6m3-2.6v1.5" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/><path d="M8 14.5h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  }

  function card(type, label, description) {
    return '<button type="button" class="fa-extra-card" data-fa-extra="' + type + '" disabled>' +
      '<span class="fa-extra-card__icon">' + icon(type) + '</span>' +
      '<span class="fa-extra-card__copy">' +
        '<span class="fa-extra-card__label">' + label + '</span>' +
        '<span class="fa-extra-card__description">' + description + '</span>' +
      '</span>' +
      '<span class="fa-extra-card__meta" data-fa-meta>…</span>' +
    '</button>';
  }

  function findPurchase() {
    var sections = document.querySelectorAll('[data-section-type="product"]');
    for (var i = 0; i < sections.length; i++) {
      var payment = sections[i].querySelector('.fa-product-purchase .product-form__payment-container, .product-form__payment-container');
      if (!payment) continue;
      var button = payment.querySelector('.product-form__add-button, [data-action="add-to-cart"], button[type="submit"]');
      if (button) return { section: sections[i], payment: payment, button: button };
    }
    return null;
  }

  function ensureMount() {
    var purchase = findPurchase();
    if (!purchase) return false;

    section = purchase.section;
    var mount = purchase.payment.querySelector('[data-fa-product-extras-mount]');
    if (!mount) {
      mount = document.createElement('div');
      mount.className = 'fa-product-extras-mount';
      mount.setAttribute('data-fa-product-extras-mount', '');
      purchase.button.insertAdjacentElement('afterend', mount);
    }

    root = mount.querySelector('.fa-product-extras');
    if (!root) {
      var text = copy();
      root = document.createElement('div');
      root.className = 'fa-product-extras';
      root.setAttribute('data-fa-product-extras', '');
      root.setAttribute('aria-label', text.aria);
      root.innerHTML = '<div class="fa-product-extras__row">' +
        card('thread', text.thread, text.threadDescription) +
        card('twenty', text.twenty, text.twentyDescription) +
        card('half', text.half, text.halfDescription) +
      '</div>';
      mount.appendChild(root);
      document.dispatchEvent(new CustomEvent('fa:extras-mounted', { detail: { root: root } }));
    }

    cards.thread = root.querySelector('[data-fa-extra="thread"]');
    cards.twenty = root.querySelector('[data-fa-extra="twenty"]');
    cards.half = root.querySelector('[data-fa-extra="half"]');
    return !!(cards.thread && cards.twenty && cards.half);
  }

  function readConfig() {
    var node = document.getElementById('fa-product-extras-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function money(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return '€' + (isBg() ? amount.replace('.', ',') : amount);
  }

  function findVariant(id) {
    id = String(id || '');
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  function currentFromForm() {
    if (!section) return current;
    var input = section.querySelector('.fa-commerce-product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (input) {
      var found = findVariant(input.value);
      if (found) current = found;
    }
    return current;
  }

  function sourcePricePerMetreCents() {
    var variant = currentFromForm();
    if (!variant) return 0;
    var raw = Number(variant.price || 0);
    return cfg && cfg.alreadyHalfMetre ? raw * 2 : raw;
  }

  function cutMatch(list) {
    var source = sourcePricePerMetreCents();
    for (var i = 0; i < (list || []).length; i++) {
      if (Number(list[i].sourceCents) === source) return list[i];
    }
    return null;
  }

  function colour() {
    var variant = currentFromForm();
    if (!variant || colorIndex < 0 || !variant.options) return '';
    return String(variant.options[colorIndex] || '');
  }

  function sku() {
    var variant = currentFromForm();
    return variant && variant.sku ? String(variant.sku) : '';
  }

  function setMeta(cardNode, text) {
    var node = cardNode && cardNode.querySelector('[data-fa-meta]');
    if (node) node.textContent = text;
  }

  function showCard(cardNode, show) {
    if (!cardNode) return;
    cardNode.hidden = !show;
  }

  function render() {
    if (!cfg || !root) return;

    var text = copy();
    var variant = currentFromForm();
    var available = !!(variant && variant.available !== false);
    var thread = cfg.thread || {};
    var cut20 = cutMatch(cfg.cut20Variants);
    var cut50 = cutMatch(cfg.cut50Variants);
    var showThread = cfg.showThread !== false;
    var show20 = cfg.show20 !== false;
    var show50 = cfg.show50 !== false;

    showCard(cards.thread, showThread);
    showCard(cards.twenty, show20);
    showCard(cards.half, show50);

    if (showThread) {
      cards.thread.disabled = !available || !thread.id || thread.available === false;
      setMeta(cards.thread, thread.id ? '+' + money(thread.price) + ' · ' + text.threadUnit : '—');
    }
    if (show20) {
      cards.twenty.disabled = !available || !cut20 || cut20.available === false;
      setMeta(cards.twenty, cut20 ? '+' + money(cut20.price) : '—');
    }
    if (show50) {
      cards.half.disabled = !available || !cut50 || cut50.available === false;
      setMeta(cards.half, cut50 ? '+' + money(cut50.price) : '—');
    }
  }

  function properties(kind) {
    var selected = currentFromForm();
    var text = copy();
    var props = { 'For fabric': cfg.product.title };
    var selectedColour = colour();
    var selectedSku = sku();

    if (selectedColour) props['Fabric colour'] = selectedColour;
    if (selectedSku) props['Fabric SKU'] = selectedSku;
    if (kind === 'thread') props['Thread selection'] = text.threadNote;
    if (kind === 'twenty') props['Cut length'] = '20 cm';
    if (kind === 'half') props['Cut length'] = '50 cm';
    props['_Fabric URL'] = window.location.pathname;
    props['_Source Variant'] = String(selected && selected.id || '');
    props['_Source price per metre'] = String(sourcePricePerMetreCents());
    return props;
  }

  function cartUrl() {
    var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return shopRoot + 'cart/add.js';
  }

  function toast(message) {
    var node = document.querySelector('.fa-extras-toast');
    if (!node) {
      node = document.createElement('div');
      node.className = 'fa-extras-toast';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.textContent = message;
    node.classList.add('is-visible');
    window.setTimeout(function () { node.classList.remove('is-visible'); }, 2200);
  }

  function signalAdded(id) {
    (section || document.documentElement).dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: { variant: { id: Number(id) }, quantity: 1 }
    }));
  }

  function addItem(id, props, button) {
    if (!id || !button) return;
    var meta = button.querySelector('[data-fa-meta]');
    var oldMeta = meta ? meta.textContent : '';
    button.classList.add('is-loading');
    button.disabled = true;

    fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: props }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart error');
      return response.json();
    }).then(function () {
      signalAdded(id);
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.disabled = false;
      if (meta) meta.textContent = copy().added;
      window.setTimeout(function () {
        button.classList.remove('is-added');
        if (meta) meta.textContent = oldMeta;
        render();
      }, 1200);
    }).catch(function () {
      button.classList.remove('is-loading');
      button.disabled = false;
      toast(copy().error);
    });
  }

  function bind() {
    if (initialized || !cfg || !cards.thread || !cards.twenty || !cards.half) return;
    initialized = true;

    cards.thread.addEventListener('click', function () {
      var thread = cfg.thread || {};
      if (thread.id) addItem(thread.id, properties('thread'), cards.thread);
    });
    cards.twenty.addEventListener('click', function () {
      var match = cutMatch(cfg.cut20Variants);
      if (match) addItem(match.id, properties('twenty'), cards.twenty);
    });
    cards.half.addEventListener('click', function () {
      var match = cutMatch(cfg.cut50Variants);
      if (match) addItem(match.id, properties('half'), cards.half);
    });

    document.addEventListener('variant:changed', function (event) {
      var detail = event && event.detail && event.detail.variant;
      if (detail && detail.id) {
        var variant = findVariant(detail.id);
        if (variant) current = variant;
      }
      window.requestAnimationFrame(render);
    });
  }

  function hydrate() {
    cfg = cfg || readConfig();
    if (!cfg || !cfg.product) return false;

    variants = cfg.product.variants || [];
    current = current || findVariant(cfg.product.selectedVariantId) || variants[0] || null;
    colorIndex = -1;
    var optionNames = cfg.product.optionNames || [];
    for (var i = 0; i < optionNames.length; i++) {
      if (/color|colour|цвят/i.test(String(optionNames[i]))) {
        colorIndex = i;
        break;
      }
    }
    if (colorIndex < 0 && variants.length > 1 && optionNames.length) colorIndex = 0;

    bind();
    render();
    return true;
  }

  function attempt() {
    attempts += 1;
    cfg = cfg || readConfig();

    /*
     * Do not mount disabled placeholder cards when this product has no
     * tag-enabled extras. The Liquid config is intentionally absent unless at
     * least one of FA_ADD_THREAD, FA_ADD_20CM, or FA_ADD_50CM applies.
     */
    if (!cfg || !cfg.product) {
      var staleMount = document.querySelector('[data-fa-product-extras-mount]');
      if (staleMount) staleMount.remove();

      if (document.readyState === 'loading' && attempts < maxAttempts) {
        if (retryTimer) window.clearTimeout(retryTimer);
        retryTimer = window.setTimeout(attempt, 100);
      }
      return;
    }

    var mounted = ensureMount();
    var hydrated = mounted && hydrate();
    if (mounted && hydrated) {
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = null;
      return;
    }
    if (attempts < maxAttempts) {
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(attempt, 100);
    }
  }

  attempt();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt, { once: true });
  }
  window.addEventListener('load', attempt, { once: true });

  document.addEventListener('shopify:section:load', function () {
    attempts = 0;
    initialized = false;
    cfg = null;
    current = null;
    window.setTimeout(attempt, 20);
  });
})();
